/* eslint-disable no-multi-spaces */
/* forgive me my table-style alignment,
 * otherwise it is uncomfortable to check regular expressions */
const adminHomepageRegex         = /^\/admin\/?$/;
const adminCreateCollectionRegex = /^\/admin\/collections\/create\?$/;
const adminEditCollectionRegex   = /^\/admin\/collections\/[^/]+\/?$/;
const adminListFilesRegex        = /^\/admin\/collections\/[^/]+\/files\/?$/;
const adminCreateFileRegex       = /^\/admin\/collections\/[^/]+\/files\/create\/?$/;
const adminEditFileRegex         = /^\/admin\/collections\/[^/]+\/files\/[^/]+\/?$/;
const adminAnalytics             = /^\/admin\/analytics\/?$/;

const mainHomepageRegex  = /^\/?$/;
const mainListFilesRegex = /^\/collections\/[^/]+\/files\/?$/;
const mainViewFileRegex  = /^\/collections\/[^/]+\/(?:video|doc)\/[^/]+\/?$/;

export const ADMIN_HOMEPAGE          = 'ADMIN_HOMEPAGE';
export const ADMIN_CREATE_COLLECTION = 'ADMIN_CREATE_COLLECTION';
export const ADMIN_EDIT_COLLECTION   = 'ADMIN_EDIT_COLLECTION';
export const ADMIN_LIST_FILES        = 'ADMIN_LIST_FILES';
export const ADMIN_CREATE_FILE       = 'ADMIN_CREATE_FILE';
export const ADMIN_EDIT_FILE         = 'ADMIN_EDIT_FILE';
export const ADMIN_ANALYTICS         = 'ADMIN_ANALYTICS';

export const MAIN_HOMEPAGE   = 'MAIN_HOMEPAGE';
export const MAIN_LIST_FILES = 'MAIN_LIST_FILES';
export const MAIN_VIEW_FILE  = 'MAIN_VIEW_FILE';

export function ejectLast(pathname) {
	return pathname.replace(/\/[^/]+\/?$/, '');
}

export function isAdminHomepage(pathname) {
	return adminHomepageRegex.test(pathname);
}

export function getAdminRoute(pathname) {
	if (adminHomepageRegex.test(pathname)) {
		return ADMIN_HOMEPAGE;
	} else if (adminCreateCollectionRegex.test(pathname)) {
		return ADMIN_CREATE_COLLECTION;
	} else if (adminEditCollectionRegex.test(pathname)) {
		return ADMIN_EDIT_COLLECTION;
	} else if (adminListFilesRegex.test(pathname)) {
		return ADMIN_LIST_FILES;
	} else if (adminCreateFileRegex.test(pathname)) {
		return ADMIN_CREATE_FILE;
	} else if (adminEditFileRegex.test(pathname)) {
		return ADMIN_EDIT_FILE;
	} else if (adminAnalytics.test(pathname)) {
		return ADMIN_ANALYTICS;
	}
}

export function isMainHomepage(pathname) {
	return mainHomepageRegex.test(pathname);
}

export function getMainRoute(pathname) {
	if (mainHomepageRegex.test(pathname)) {
		return MAIN_HOMEPAGE;
	} else if (mainListFilesRegex.test(pathname)) {
		return MAIN_LIST_FILES;
	} else if (mainViewFileRegex.test(pathname)) {
		return MAIN_VIEW_FILE;
	}
}



// WEBPACK FOOTER //
// ./src/client/routes/utils/index.js